import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespace } from '../../../translation/namespace';

import Event from '../../../lib/EventEmitter';
import { GlobalDocumentIds } from '../../../types/GlobalDocumentIds';

/**
 * Loading bar animation with live region for screen readers.
 *
 * Using Events to trigger animation as it is rendered outside of Router
 * but needs to be aware of location changes
 */
export default function LoadingFeedback() {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation(Namespace.LoadingFeedback);

  useEffect(() => {
    Event.register(Event.loadingFeedback.start, () => setIsLoading(true));
    Event.register(Event.loadingFeedback.stop, () => setIsLoading(false));

    return () => {
      Event.remove(Event.loadingFeedback.start);
      Event.remove(Event.loadingFeedback.stop);
    };
  }, []);

  const modifier = isLoading ? 'loading' : 'ready';

  return (
    <div id={GlobalDocumentIds.loadingFeedback} className={`loading-feedback loading-feedback--${modifier}`}>
      <div className="loading-feedback__bar-container">
        <span className="loading-feedback__bar" />
      </div>
      <div className="invisible" aria-live="assertive" aria-atomic="true">
        {isLoading ? t('loading') : ''}
      </div>
    </div>
  );
}
